import * as o from "react";
import a from "../lib/IconBase.es.js";
import m from "../defs/FlowArrow.es.js";
const r = o.forwardRef((e, t) => /* @__PURE__ */ o.createElement(a, { ref: t, ...e, weights: m }));
r.displayName = "FlowArrowIcon";
const s = r;
export {
  s as FlowArrow,
  r as FlowArrowIcon
};
